export const switchConstants = {
    SOCIAL_MEDIA: 'SOCIALMEDIA',
    ACCOUNT: 'ACCOUNT',
    HACKED: 'HACKED',

    SOCIAL_MEDIA_NR: 0,
    ACCOUNT_NR: 1,
    HACKED_NR: 2,
  
};